<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <high-payout-report-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import HighPayoutReportTable from './HighPayoutReportTable.vue'

  export default {
    name: 'highpayout-report',
    components: {HighPayoutReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/risk/game/HighPayoutReport.vue